document.querySelectorAll(".accordion-btn").forEach((button) => {
  button.addEventListener("click", function () {
    const content = this.nextElementSibling;
    const icon = this.querySelector("span:last-child");

    const isOpen = content.classList.contains("show");

    document.querySelectorAll(".accordion-content").forEach((panel) => {
      panel.style.maxHeight = null;
      panel.classList.remove("show");
      panel.previousElementSibling.querySelector("span:last-child").textContent = "+";
    });

    if (!isOpen) {
      content.classList.add("show");
      content.style.maxHeight = content.scrollHeight + "px";
      icon.textContent = "-";

      setTimeout(() => {
        content.style.maxHeight = content.scrollHeight + "px";
      }, 100);
    }
  });
});
